export default {"src":"/_next/static/media/super-stars.9ddd2ef4.svg","height":130,"width":130,"blurWidth":0,"blurHeight":0};